// extracted by mini-css-extract-plugin
export var actionButton = "_yj-2";
export var card = "_yj-0";
export var errorCard = "_yj-1";